<template>

    <v-container class="align-center flex-row mb-6 pa-0">

        <p class="text-headline-small mb-4">Identificazione</p>

        <v-select v-model="properties.specie_id" :items="speciedanni" label="Specie" item-title="label" hide-details
            class="mb-6" />
    </v-container>

    <SegnalazioneCommon v-model="properties" />

    <v-alert 
        v-if="props.isNew"
        type="info"
        title="Geometria"
        variant="outline"
        >
        Ricordati di modificare la geometria, dopo aver <strong class="">confermato</strong> l'elemento
    </v-alert>

</template>

<script setup>


import SegnalazioneCommon from "@/reports/components/SegnalazioneCommon";
import baseData from '@/assets/catalog/TrackerForms.json'
import { computed, onMounted, watch } from 'vue'


const properties = defineModel()

const props = defineProps({
    "isNew": {
        type: Boolean,
        default: false
    }
})

const speciedanni = baseData.lookup.speciedanni

const loadDefaults = () => {
    properties.value.label = "Danni"
    properties.value.specie_id = speciedanni[1].value
    // 0 altro
    // 1 cinghiali
}

watch(() => properties.value.segni_id, (newVal,) => {
})


onMounted(() => {
    if (props.isNew) {
        loadDefaults()
    }
})
</script>
